import { FontFamily } from '@tiptap/extension-text-style'

export type { FontFamilyOptions } from '@tiptap/extension-text-style'
export { FontFamily } from '@tiptap/extension-text-style'

export default FontFamily
